export default __webpack_public_path__ + "static/media/Ataur-rahman-Resume.a807417b.pdf";